import React, { useState, useEffect } from "react"
import { BaseUrl } from "../utils/config"
import closeModalIcon from "../../assets/images/times-circle-regular.svg"
import "../../assets/css/modal.css"
import BigNumber from "bignumber.js"
import swal from "sweetalert"
import axios from "axios"
import erc20Abi from "../../assets/blockchain/erc20Abi.json"
import nftAbi from "../../assets/blockchain/nftAbi.json"
import constant from "../../constants/constants"
import Web3 from "web3"
import Cookies from "universal-cookie"
import { updateUserDetailsRedux } from "../../redux/actions"
import { useNavigate } from "@reach/router"
import { useDispatch } from "react-redux"

const cookies = new Cookies()

function Modal({ showModal, toggleModalView, children, balance, tier }) {
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const getInitialState = () => {
    const payToken = "0x0000000000000000000000000000000000000000" // Zero Address
    return payToken
  }

  let [payToken, setPayToken] = useState(getInitialState)
  let [isAlreadyApproved, setIsAlreadyApproved] = useState(false)
  let [isApprovedTxAvailable, setIsApprovedTxAvailable] = useState(false)
  let [isPayTxAvailable, setIsPayTxAvailable] = useState(false)
  let [approvedTx, setApprovedTx] = useState(null)
  let [payTx, setPayTx] = useState(null)
  let [web3, setWeb3] = useState(null)
  let [isWalletConnected, setWalletConnected] = useState(false)
  let [connectedWallet, setConnectedWallet] = useState(null)
  let [selectedTierInMint, setSelectedTier] = useState(null)
  let [amountPaid, setAmountPaid] = useState(0)

  const loginUserMail = localStorage.getItem("loginUserMail")
  const loginUserToken = localStorage.getItem("loginUserToken")

  const approveNFTContract = async () => {
    if (isWalletConnected == true) {
      await connectToWallet()

      let web3 = new Web3(window.ethereum)
      let accounts = await web3.eth.getAccounts()

      console.log(
        "[nft][src][components][components][modalmint][approveNFTContract] Initiated"
      )
      console.log(
        "[nft][src][components][components][modalmint][approveNFTContract] Selected Token to Pay",
        payToken
      )
      let contractToApprove = null
      let selectedTier = tier.toLowerCase()

      if (selectedTier === "tier-1") {
        contractToApprove = constant.TIER_1_NFT_CONTRACT_ADDRESS
      } else if (selectedTier === "tier-2") {
        contractToApprove = constant.TIER_2_NFT_CONTRACT_ADDRESS
      } else if (selectedTier === "tier-3") {
        contractToApprove = constant.TIER_3_NFT_CONTRACT_ADDRESS
      }

      let valueToApprove =
        "0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff"

      let ERC20 = await new web3.eth.Contract(erc20Abi, payToken)

      try {
        await ERC20.methods
          .approve(contractToApprove, valueToApprove)
          .send({ from: accounts[0] })
          .on("transactionHash", function (hash) {
            setIsApprovedTxAvailable(true)
            console.log(
              "[nft][src][components][components][modalmint][approveNFTContract] Approve Tx Hash",
              hash
            )
            let txHash = `${constant.EXPLORER_URL}/tx/${hash}`
            setApprovedTx(txHash)
            waitTransactionReceipt(hash, "approve", 0, function (err, receipt) {
              if (err != null) {
                return
              }
            })
          })
          .on("error", function (error, receipt) {
            console.log(
              "[nft][src][components][components][modalmint][approveNFTContract] Approve Tx Error",
              error
            )
            swal({
              icon: "error",
              title: "Failed",
              text: "Transaction cancelled. Please try again!",
              showConfirmButton: true,
              showCancelButton: false,
              allowOutsideClick: true
            })
            setIsAlreadyApproved(false)
            return
          })
      } catch (error) {
        console.log(
          "[nft][src][components][components][modalmint][approveNFTContract] Approve Tx Error",
          error
        )
        swal({
          icon: "error",
          title: "Failed",
          text: "Something went wrong. Please try again!",
          showConfirmButton: true,
          showCancelButton: false,
          allowOutsideClick: true
        })
        setIsAlreadyApproved(false)
      }
    } else {
      await connectToWallet()
      swal({
        title: "Failed",
        text: `Please connect your wallet.`,
        icon: "error",
        confirmButtonText: "Ok"
      })
    }
  }

  const waitTransactionReceipt = async (
    transactionHash,
    actionType,
    timeOut,
    callback
  ) => {
    console.log(
      "[nft][src][components][components][modalmint][waitTransactionReceipt] transactionHash",
      transactionHash
    )

    var web3 = new Web3(window.ethereum)
    let self = this

    let timeOutCounter = 0
    let err = {
      message: ""
    }

    let isWaitRunning = false

    let getReceiptTimerId = setInterval(function () {
      if (isWaitRunning == false) {
        isWaitRunning = true
        web3.eth
          .getTransaction(transactionHash)
          .then(function (tx) {
            if (tx == null) {
              clearInterval(getReceiptTimerId)
              console.log(`Transaction hash ${transactionHash} is not found.`)
              err.message = "Transaction hash is not found."
              isWaitRunning = false
              if (callback) {
                callback(err, null)
              }
              return
            }

            if (tx.blockNumber == null) {
              if (timeOut > 0) {
                timeOutCounter++
                if (timeOutCounter >= timeOut) {
                  clearInterval(getReceiptTimerId)
                  isWaitRunning = false
                  err.message = "Timeout while waiting transaction to confirm."
                  if (callback) {
                    callback(err, null)
                  }
                  return
                } else {
                  console.log(
                    `[nft][src][components][components][modalmint][waitTransactionReceipt] transactionHash 1 ${transactionHash} is pending`
                  )
                  isWaitRunning = false
                  return
                }
              } else {
                console.log(
                  `[nft][src][components][components][modalmint][waitTransactionReceipt] transactionHash 2 ${transactionHash} is pending`
                )
                isWaitRunning = false
                return
              }
            }

            // Transaction confirm
            web3.eth
              .getTransactionReceipt(transactionHash)
              .then(async function (web3TxReceipt) {
                clearInterval(getReceiptTimerId)
                isWaitRunning = false
                if (web3TxReceipt == null) {
                  console.log(
                    `[nft][src][components][components][modalmint][waitTransactionReceipt] transactionHash 2 ${transactionHash} is not found`
                  )
                  swal({
                    icon: "error",
                    title: "Failed",
                    text: "Transaction Failed. Please try again!",
                    showConfirmButton: true,
                    showCancelButton: false,
                    allowOutsideClick: true
                  }).then(() => {
                    setIsAlreadyApproved(false)
                  })
                }
                console.log(
                  `Transaction receipt ${transactionHash}: `,
                  web3TxReceipt
                )
                if (actionType == "approve") {
                  swal({
                    icon: "success",
                    title: "Approved",
                    text: "Transaction Successful, Please proceed with minting NFT",
                    showConfirmButton: true,
                    showCancelButton: false,
                    allowOutsideClick: true
                  })
                  setIsAlreadyApproved(true)
                } else if (actionType == "pay") {
                  //⚠️ ⚠️ ⚠️ Payment Update API to be done here! ⚠️ ⚠️ ⚠️//

                  let selectedTier = null

                  if (tier == "tier-1") {
                    selectedTier = 1
                  } else if (tier == "tier-2") {
                    selectedTier = 2
                  } else if (tier == "tier-3") {
                    selectedTier = 3
                  } else {
                    selectedTier = null
                  }

                  axios
                    .post(
                      `${BaseUrl}/paymentcryptomint`,
                      {
                        tx_hash: transactionHash,
                        tier: selectedTier,
                        user_email: loginUserMail,
                        user_wallet: connectedWallet,
                        amount_paid: balance,
                        amount_token: payToken
                      },
                      {
                        headers: {
                          Authorization: `Bearer ${loginUserToken}`
                        }
                      }
                    )
                    .then(response => {
                      if (response) {
                        swal({
                          icon: "success",
                          title: "Success",
                          text: "NFT Minted Successful",
                          showConfirmButton: true,
                          showCancelButton: false,
                          allowOutsideClick: true
                        }).then(() => {
                          refreshPage()
                          setIsPayTxAvailable(true)
                        })
                      }
                    })
                }
              })
              .catch(function (error) {
                if (error?.response?.status === 401) {
                  localStorage.clear()
                  dispatch(updateUserDetailsRedux({}))
                  navigate("/login")
                }
                clearInterval(getReceiptTimerId)
                isWaitRunning = false
                console.log(
                  `[nft][src][components][components][modalmint][waitTransactionReceipt] Error on transaction receipt 1 ${transactionHash}: ${error}`
                )
                swal({
                  icon: "error",
                  title: "Cancelled",
                  text: error.message,
                  showConfirmButton: true,
                  showCancelButton: false,
                  allowOutsideClick: true
                })
                setIsAlreadyApproved(false)
              })
          })
          .catch(function (error) {
            clearInterval(getReceiptTimerId)
            console.log(
              `[nft][src][components][components][modalmint][waitTransactionReceipt] Error on transaction receipt 2 ${transactionHash}: ${error}`
            )
            swal({
              icon: "error",
              title: "Cancelled",
              text: error.message,
              showConfirmButton: true,
              showCancelButton: false,
              allowOutsideClick: true
            })
            setIsAlreadyApproved(false)
          })
      }
    }, 1000)
  }

  const mintNFT = async () => {
    console.log(
      `[nft][src][components][components][modalmint][mintNFT] Initiated`
    )
    console.log(
      `[nft][src][components][components][modalmint][mintNFT] Selected Token`,
      payToken
    )
    console.log(
      `[nft][src][components][components][modalmint][mintNFT] Selected Tier`,
      tier
    )

    await connectToWallet()

    let web3 = new Web3(window.ethereum)
    let accounts = await web3.eth.getAccounts()

    let selectedTier = tier.toLowerCase()

    try {
      let ERC20 = await new web3.eth.Contract(erc20Abi, payToken)
      let userBalance = await ERC20.methods.balanceOf(connectedWallet).call()
      let userBalanceBN = new BigNumber(userBalance)

      let decimal = await ERC20.methods.decimals().call()
      let decimalBN = new BigNumber(decimal)

      let baseBN = new BigNumber(10)
      let nftCost

      if (selectedTier === "tier-1") {
        nftCost = new BigNumber(constant.TIER_1_COST)
        setAmountPaid(constant.TIER_1_COST)
      } else if (selectedTier === "tier-2") {
        nftCost = new BigNumber(constant.TIER_2_COST)
        setAmountPaid(constant.TIER_2_COST)
      } else if (selectedTier === "tier-3") {
        nftCost = new BigNumber(constant.TIER_3_COST)
        setAmountPaid(constant.TIER_3_COST)
      }

      setSelectedTier(selectedTier)

      let balanceToPay = new BigNumber(nftCost)
      let exponentiate = baseBN.exponentiatedBy(decimalBN)
      let balanceToPayBN = new BigNumber(balanceToPay).multipliedBy(
        exponentiate
      )
      let res = userBalanceBN.comparedTo(balanceToPayBN)

      if (res === -1) {
        swal({
          icon: "error",
          title: "Failed",
          text: "Insufficient Funds. Please topup your wallet to proceed for payment",
          showConfirmButton: true,
          showCancelButton: false,
          allowOutsideClick: true
        })
        return
      }

      let NitroNFT = null

      if (selectedTier === "tier-1") {
        NitroNFT = await new web3.eth.Contract(
          nftAbi,
          constant.TIER_1_NFT_CONTRACT_ADDRESS
        )
      } else if (selectedTier === "tier-2") {
        NitroNFT = await new web3.eth.Contract(
          nftAbi,
          constant.TIER_2_NFT_CONTRACT_ADDRESS
        )
      } else if (selectedTier === "tier-3") {
        NitroNFT = await new web3.eth.Contract(
          nftAbi,
          constant.TIER_3_NFT_CONTRACT_ADDRESS
        )
      }

      await NitroNFT.methods
        .pay(payToken)
        .send({ from: accounts[0] })
        .on("transactionHash", function (hash) {
          setIsPayTxAvailable(true)
          console.log(
            `[nft][src][components][components][modalmint][mintNFT] transactionHash`,
            hash
          )
          let txHash = `${constant.EXPLORER_URL}/tx/${hash}`
          setPayTx(txHash)
          waitTransactionReceipt(hash, "pay", 0, function (err, receipt) {
            if (err != null) {
              return
            }
          })
        })
        .on("error", function (error, receipt) {
          console.log(
            `[nft][src][components][components][modalmint][mintNFT] transactionHash error 1`,
            error
          )
          swal({
            icon: "error",
            title: "Failed",
            text: "Transaction cancelled. Please try again!",
            showConfirmButton: true,
            showCancelButton: false,
            allowOutsideClick: true
          })
          return
        })
    } catch (error) {
      console.log(
        `[nft][src][components][components][modalmint][mintNFT] transactionHash error 2`,
        error
      )
      swal({
        icon: "error",
        title: "Failed",
        text: "Something went wrong. Please try again!",
        showConfirmButton: true,
        showCancelButton: false,
        allowOutsideClick: true
      })
    }
  }

  const handlePayTokenChange = e => {
    let selectedToken = e.target.value
    setPayToken(selectedToken)
    isNFTContractApproved(selectedToken)
    console.log(
      `[nft][src][components][components][modalmint][handlePayTokenChange] selectedToken`,
      selectedToken
    )
  }

  const isNFTContractApproved = async selectedToken => {
    console.log(
      `[nft][src][components][components][modalmint][isNFTContractApproved] selectedToken`,
      selectedToken
    )

    if (
      selectedToken != "null" ||
      selectedToken != "0x0000000000000000000000000000000000000000"
    ) {
      let erc20 = await new web3.eth.Contract(erc20Abi, selectedToken)

      // balance to Pay
      let balanceToPay = new BigNumber(balance)

      let selectedTier = tier.toLowerCase()

      let nftContract = null

      if (selectedTier === "tier-1") {
        nftContract = constant.TIER_1_NFT_CONTRACT_ADDRESS
      } else if (selectedTier === "tier-2") {
        nftContract = constant.TIER_2_NFT_CONTRACT_ADDRESS
      } else if (selectedTier === "tier-3") {
        nftContract = constant.TIER_3_NFT_CONTRACT_ADDRESS
      }

      console.log(
        `[nft][src][components][components][modalmint][isNFTContractApproved] selectedTier`,
        selectedTier
      )
      console.log(
        `[nft][src][components][components][modalmint][isNFTContractApproved] nftContract`,
        nftContract
      )

      let isApproved = await erc20.methods
        .allowance(connectedWallet, nftContract)
        .call()

      let decimal = await erc20.methods.decimals().call()

      let baseBN = new BigNumber(10)
      let decimalBN = new BigNumber(decimal)

      let exponentiate = baseBN.exponentiatedBy(decimalBN)

      let isApprovedBN = new BigNumber(isApproved)
      let balanceToPayBN = new BigNumber(balanceToPay).multipliedBy(
        exponentiate
      )

      let res = isApprovedBN.comparedTo(balanceToPayBN)
      console.log(
        `[nft][src][components][components][modalmint][isNFTContractApproved] res`,
        res
      )

      if (res === 0 || res == 1) {
        setIsAlreadyApproved(true)
      } else if (res == -1) {
        setIsAlreadyApproved(false)
      }
      console.log(
        `[nft][src][components][components][modalmint][isNFTContractApproved] Is Approved`,
        isAlreadyApproved
      )
    } else {
      setIsAlreadyApproved(false)
    }
  }

  const getWeb3 = async () => {
    if (window.ethereum) {
      try {
        let web3 = new Web3(window.ethereum)
        let accounts = await web3.eth.getAccounts()
        let chainId = await web3.eth.getChainId()
        if (chainId !== parseInt(constant.CHAIN_ID)) {
          swal({
            title: "Invalid Network!",
            text: `Switch your network to ${constant.NETWORK_NAME}`,
            icon: "error",
            confirmButtonText: "Ok"
          })
          return
        }
        cookies.set("wallet", accounts[0], { path: "/" })
        cookies.set("wallet_status", 1, { path: "/" })
        setWalletConnected(true)
        setConnectedWallet(accounts[0])
        setWeb3(web3)
      } catch (error) {
        console.log(
          `[nft][src][components][components][modalmint][getWeb3] Web3 Connection Error`,
          error
        )
      }
    } else {
      cookies.set("wallet", null, { path: "/" })
      cookies.set("wallet_status", 0, { path: "/" })
      setWalletConnected(false)
      setConnectedWallet(null)
      setWeb3(null)
      swal({
        title: "Unsupported Browser/Plugin not installed",
        text: `Please use Google Chrome with Metamask Plugin Installed`,
        icon: "error",
        confirmButtonText: "Ok"
      })
      console.log(
        `[nft][src][components][components][modalmint][getWeb3] WUnsupported Browser/Plugin not installed.`
      )
    }
  }

  const refreshPage = () => {
    window.location.reload()
  }

  const connectToWallet = async () => {
    console.log(
      `[nft][src][components][components][pages][pendingPayments][connectToWallet] connectToWallet`
    )
    if (typeof window.ethereum !== "undefined") {
      let accounts = await window.ethereum.request({
        method: "eth_requestAccounts"
      })
      window.web3 = new Web3(window.ethereum)
      setWeb3(window.web3)
      let chainId = await window.web3.eth.getChainId()
      if (chainId !== parseInt(constant.CHAIN_ID)) {
        swal({
          title: "Invalid Network!",
          text: `Switch your network to ${constant.NETWORK_NAME}`,
          icon: "error",
          confirmButtonText: "Ok"
        })
        return
      }
      cookies.set("wallet", accounts[0], { path: "/" })
      cookies.set("wallet_status", 1, { path: "/" })
      setWalletConnected(true)
      setConnectedWallet(accounts[0])
      setWeb3(window.web3)
    } else {
      cookies.set("wallet", null, { path: "/" })
      cookies.set("wallet_status", 0, { path: "/" })
      setWalletConnected(false)
      setConnectedWallet(null)
      setWeb3(null)
      swal({
        title: "Unsupported Browser/Plugin not installed",
        text: `Please use Google Chrome with Metamask Plugin Installed`,
        icon: "error",
        confirmButtonText: "Ok"
      })
      console.log("Unsupported Browser/Plugin not installed")
    }
  }

  useEffect(() => {
    getWeb3()
  }, [])

  console.log(
    `[nft][src][components][components][modalmint][showModal] ${children} :: ${showModal} :: ${balance}`
  )

  return showModal ? (
    <>
      <div className="backdrop" onClick={toggleModalView}></div>

      <div className="modal-container">
        <div className="close-modal">
          <button onClick="close-modal" onClick={toggleModalView}>
            <i className="fa fa-times"></i>
          </button>
        </div>

        <div className="modal-content">
          <div className="btn-modal">
            <p>Please select the token to Pay</p>
          </div>
          <div className="select-items">
            <select
              name="selct-token"
              value={payToken}
              onChange={handlePayTokenChange}>
              <option value="0x0000000000000000000000000000000000000000">
                - Select Token -
              </option>
              <option value={constant.USDC}>TUSDC</option>
              <option value={constant.DAI}>TDAI</option>
            </select>
          </div>
          <div className="btn-modal">
            {isAlreadyApproved == false && (
              <span>
                {isApprovedTxAvailable == true && (
                  <span>
                    <button
                      className="approve-modal"
                      onClick={approveNFTContract}>
                      Approve transaction pending...
                    </button>
                    <a href={approvedTx} target="_blank">
                      View Transaction
                    </a>
                  </span>
                )}
                {isApprovedTxAvailable == false && (
                  <span>
                    <button
                      disabled
                      className="approve-modal"
                      onClick={approveNFTContract}>
                      Approve
                    </button>
                    <p>Please click on Approve to proceed</p>
                  </span>
                )}
              </span>
            )}
            {isAlreadyApproved == true && (
              <span>
                <button className="approve-modal">Approved</button>
                <p>Transaction Approved</p>
              </span>
            )}
          </div>
          <div className="btn-modal">
            {isAlreadyApproved == true && (
              <span>
                <button className="Pay-now-modal" onClick={mintNFT}>
                  Mint
                </button>
                {isPayTxAvailable == true && (
                  <a href={payTx} target="_blank">
                    View Transaction
                  </a>
                )}
                {isPayTxAvailable == false && (
                  <p>Please click on Pay to proceed</p>
                )}
              </span>
            )}
            {isAlreadyApproved == false && (
              <span>
                <button className="Pay-now-modal">Mint</button>
                <p>Please Approve to Pay</p>
              </span>
            )}
          </div>
        </div>

        {/* {children} */}
      </div>
    </>
  ) : null
}

export default Modal
